/**
 * Panel tạo tài khoản admin mới — form tên, email, SĐT và mật khẩu tạm.
 */
import { ButtonSpinner } from '../Common/ButtonSpinner';
import { PhoneInput } from '../Common/PhoneInput';

export const AdminUsersCreatePanel = ({
  users,
  common,
  adminForm,
  phoneError,
  isCreatingAdmin,
  onFieldChange,
  onSubmit,
}) => (
  <aside className="admin-users-create-panel">
    <form className="admin-users-create-form" onSubmit={onSubmit}>
      <div className="admin-users-create-head">
        <span className="admin-users-create-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
            <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
            <rect x="4" y="4" width="16" height="16" rx="4" stroke="currentColor" strokeWidth="1.75" />
          </svg>
        </span>
        <div>
          <h2>{users.createTitle}</h2>
          <p>{users.createHint}</p>
        </div>
      </div>

      <div className="admin-users-create-fields">
        <label>
          {users.fullName}
          <input
            autoComplete="name"
            value={adminForm.name}
            onChange={(event) => onFieldChange('name', event.target.value)}
            required
          />
        </label>
        <label>
          {users.email}
          <input
            type="email"
            autoComplete="email"
            value={adminForm.email}
            onChange={(event) => onFieldChange('email', event.target.value)}
            required
          />
        </label>
        <label>
          {users.phone}
          <PhoneInput
            value={adminForm.phone}
            onChange={(value) => onFieldChange('phone', value)}
          />
          {phoneError && <span className="field-hint field-hint--error">{phoneError}</span>}
        </label>
        <label>
          {users.tempPassword}
          <input
            type="password"
            autoComplete="new-password"
            minLength="8"
            value={adminForm.password}
            onChange={(event) => onFieldChange('password', event.target.value)}
            required
          />
        </label>
      </div>

      <button className="button full-width" disabled={isCreatingAdmin}>
        {isCreatingAdmin && <ButtonSpinner />}
        {isCreatingAdmin ? common.creating : users.createButton}
      </button>
    </form>
  </aside>
);
